var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.3835,
    stroke: "#FEFEFE",
    strokeWidth: 1.23298
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7119 18.1744L28.4124 10.5527H26.8243L21.0078 17.1703L16.3599 10.5527H11L18.0274 20.5607L11 28.5527H12.5881L18.7315 21.5636L23.6401 28.5527H29L21.7119 18.1744ZM19.5375 20.6482L18.8255 19.6517L13.1598 11.7227H15.5989L20.1701 18.1217L20.8821 19.1182L26.8256 27.4367H24.3865L19.5375 20.6482Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e104b916c129070c5030e2399e50eeb5.svg";
export { ForwardRef as ReactComponent };